import script from "./recordVideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./recordVideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./recordVideoComponent.vue?vue&type=style&index=0&id=aedb2a2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aedb2a2c"]])

export default __exports__